import request, { IServerResponse } from '@/utils/request';
import { IhistoryCard, IProivderContact, IUpdateProviderContactReq } from './define';

/** 获取售后历史列表 */
export const getHistoryList = (orderViewId: string): Promise<IServerResponse<IhistoryCard[]>> =>
    request.get('/api/after/sale/history', { orderViewId });

/** 获取服务商退货联系方式 */
export const getProviderContact = (
    providerId: string,
): Promise<IServerResponse<IProivderContact>> =>
    request.get('/api/after/sale/return/contact', { providerId });

/** 保存服务商退货联系方式 */
export const updateProviderContact = (
    params: IUpdateProviderContactReq,
): Promise<IServerResponse<null>> => request.post('/api/after/sale/return/contact', params);
